/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Capture_VerifyInputs */



/**
* | output |
* | --- |
* | "Re-read the bot's intents from Discord" |
*
* @param {Activity_Capture_VerifyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_capture_verify = /** @type {((inputs?: Activity_Capture_VerifyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Capture_VerifyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Интенты бота перепроверены в Discord")
	return /** @type {LocalizedString} */ ("Re-read the bot's intents from Discord")
});